<ng-container *transloco="let t">
  <form #filterRacesForm="ngForm">

    <div class="filter-toolbar">
      <div class="filter-main">
        @if (showSearchBar) {
          <div class="search-wrapper">
            <app-search (searchQuery)="handleInput($event)" [inputValue]="searchTerm"
                        [placeholder]="t('search.placeholder.races')"/>
          </div>
        }

        @if (showDateFilter) {
          <app-month-picker-mobile [minDate]="minDate"
                                   [maxDate]="maxDate"
                                   [title]="t('app.common.date')"
                                   [chosenFrom]="chosenMonthRange"
                                   [chosenTo]="chosenMonthRange"
                                   (monthsSelected)="dateChanged($event)"/>
        }

        @for (group of filterGroups | mapToArray; track group.key) {
          <app-filter-item [title]="t(group.labelKey)"
                           [items]="group.items"
                           [id]="group.key + 'Filter'"
                           [type]="group.type"
                           [allowSearchItems]="group.allowSearching"
                           (onChange)="changeFilter($event, group.key)"/>
        }
      </div>

      @if (showLayoutButton) {
        <div class="layout-buttons">
          <div class="layout-btn p-2" [class.active]="currentLayout === CalendarViewType.LIST"
               (click)="changeLayout(CalendarViewType.LIST)">
            <i class="bi bi-list-task"></i>
          </div>
          <div class="layout-btn p-2" [class.active]="currentLayout === CalendarViewType.GRID"
               (click)="changeLayout(CalendarViewType.GRID)">
            <i class="bi bi-grid-3x3"></i>
          </div>
        </div>
      }
    </div>

    @if (showFilterChips && showClearAll) {
      <div class="active-filters">
        @if (chosenMonthRange?.from || chosenMonthRange?.to) {
          <button type="button" class="filter-chip-active" (click)="dateChanged()">
            <span>{{ t('app.common.date') }}: {{ chosenMonthRange!.from | dateRangePipe:chosenMonthRange!.to }}</span>
            <img src="./assets/img/svg/close.svg" alt="Close" class="close-icon">
          </button>
        }

        @for (group of filterGroups | mapToArray; track group.key) {
          @for (filter of group.items; track filter.id) {
            @if (filter.selected) {
              <button type="button" class="filter-chip-active" (click)="removeFilter(group.key, filter)">
                <span>{{ t(group.labelKey) }}: {{ filter.labelKey ? t(filter.labelKey) : (filter.label ?? '-') }}</span>
                <img src="./assets/img/svg/close.svg" alt="Close" class="close-icon">
              </button>
            }
          }
        }

        <button type="button" class="filter-clear-all" (click)="clearAllFilters()">
          {{ t('app.common.filters.clearAll') }}
        </button>
      </div>
    }

  </form>
</ng-container>
